import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { getAllEmployees } from '../actions'
import ShiftRecord from './ShiftRecord'

const MainTable =  ({ restaurantId, shifts }) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllEmployees(restaurantId))
  }, [dispatch, restaurantId]);
  const employees = useSelector(state => state.employees);
  return shifts.length === 0 ? (<div><b>No shifts</b></div>)
  :
  (<div>
    {shifts.map((shift, i) => (
        <ShiftRecord restaurantId={restaurantId} employees={employees} shift={shift} key={i} sid={i} shiftID={shift.ID}/>
    ))}
  </div>)
}

export default MainTable